import { ia } from 'lib/helpers/utility';

const setMultipleQueriesData = (queryClient, queries, data) => {
  queries.forEach((query) => {
    queryClient.setQueriesData(ia(query) ? query : [query], data);
  });
};

export default setMultipleQueriesData;
